import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { COUNTRIES, imgUrl } from "@/data/content";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

export const CountryCard = ({ country }) => (
  <Link
    to={["jamaica", "ghana"].includes(country.slug) ? `/countries/${country.slug}` : "/countries"}
    data-testid={`country-card-${country.slug}`}
    className="group flex flex-col border border-atlantic/10 bg-white transition-shadow duration-300 hover:shadow-[0_18px_50px_-20px_rgba(10,25,47,0.25)]"
  >
    <div className="overflow-hidden">
      <img
        src={imgUrl(country.image, 800)}
        alt={`${country.name} — documentary imagery`}
        loading="lazy"
        className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105"
      />
    </div>
    <div className="flex flex-1 flex-col p-6">
      <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-ocean">{country.region}</p>
      <h3 className="mt-2 font-serif text-xl text-atlantic">{country.name}</h3>
      <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">{country.focus}</p>
      {["jamaica", "ghana"].includes(country.slug) ? (
        <span className="mt-5 inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-atlantic transition-colors group-hover:text-gold">
          Country Dossier <ArrowUpRight size={14} />
        </span>
      ) : (
        <span className="mt-5 inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-400">
          Dossier in development
        </span>
      )}
    </div>
  </Link>
);

export default function CountryDossiers() {
  return (
    <section id="countries" data-testid="countries-section" className="bg-sand py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          chapter="03"
          kicker="Country Dossiers"
          title="Evidence-Rich Country Profiles"
          copy="Country profiles combining development priorities, institutions, policy context, story leads and partnership opportunities — built for journalists, researchers and institutions."
        />
        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {COUNTRIES.map((c, i) => (
            <Reveal key={c.slug} delay={i * 0.07}>
              <CountryCard country={c} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
